<template>
  <v-flex xs12>
    <v-card>
      <v-card-title>
        <v-flex xs3>
          <v-toolbar-title>Category</v-toolbar-title>
        </v-flex>
        <v-flex xs6>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex class="text-right" xs3>
          <v-btn to="/category/add" dark color="indigo">
            <v-icon dark>add_circle</v-icon>New
          </v-btn>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="body"
        :search="search"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
      >
        <template v-slot:item.name="{ item }">
          <a :href="'/category/edit/' + item.id">{{ item.name }}</a>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="faqItem(item)">question_answer</v-icon>
          <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
          <v-icon small @click="deleteItem(item)">delete</v-icon>
        </template>
        <template v-slot:no-data>
          <v-alert :value="true">No results found.</v-alert>
        </template>
      </v-data-table>
    </v-card>
  </v-flex>
</template>

<script>
import commonservice from "../../shared/common.service";
export default {
  data() {
    return {
      search: "",
      loading: false,
      options: {},
      total: 0,
      headers: [
        { text: "Name", value: "name" },
        { text: "Sort", value: "sort" },
        { text: "Actions", value: "action", sortable: false }
      ],
      body: []
    };
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    }
  },
  methods: {
    editItem(item) {
      this.$router.push("/category/edit/" + item.id);
    },
    faqItem(item) {
      this.$router.push("/category/faq/" + item.id);
    },
    deleteItem(item) {
      commonservice
        .showDialog("Delete", "Are you sure, you want to delete category?")
        .then(result => {
          if (result.value) {
            this.$store
              .dispatch("category/deleteCategory", { id: item.id })
              .then(() => {
                this.getData();
                commonservice.showSuccessMessage(
                  "Category deleted successfully"
                );
              });
          }
        });
    },
    getData() {
      this.$store
        .dispatch("category/loadCategory", {
          pagination: this.options,
          search: this.search
        })
        .then(response => {
          this.loading = false;
          this.body = response.data.data;
          this.total = response.data.total;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
